/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remaining_TimeInputs */



/**
* | output |
* | --- |
* | "Remaining Time" |
*
* @param {Remaining_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remaining_time = /** @type {((inputs?: Remaining_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remaining_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Temps restant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbleibende Zeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempo rimanente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оставшееся время")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tiempo restante")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("剩余时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("残り時間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शेष समय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tempo restante")
	return /** @type {LocalizedString} */ ("Remaining Time")
});